import { getThemeColors } from "../lib/theme";

interface StatCardProps {
  label: string;
  value: string;
  isDark: boolean;
  delay?: number;
  truncate?: boolean;
}

export function StatCard({
  label,
  value,
  isDark,
  delay = 0,
  truncate = false,
}: StatCardProps) {
  const theme = getThemeColors(isDark);

  return (
    <div
      className={`p-6 ${theme.bg} flex flex-col items-center justify-center text-center`}
      style={{ animationDelay: `${delay * 100}ms` }}
    >
      <div
        className={`text-2xl sm:text-3xl font-bold tracking-tight ${theme.text} ${truncate ? "truncate max-w-full" : ""}`}
      >
        {value}
      </div>
      <div
        className={`text-xs uppercase tracking-widest mt-2 ${theme.textMuted} font-mono`}
      >
        {label}
      </div>
    </div>
  );
}
